import apiClient from '../../lib/axios';

export const fetchContracts = async ({
  page = 1,
  pageSize = 10,
  isActive,
  search,
  status,
} = {}) => {
  const params = new URLSearchParams();
  params.append('page', page);
  params.append('limit', pageSize);
  if (typeof isActive === 'boolean') params.append('isActive', isActive);
  if (search) params.append('search', search);
  if (status) params.append('status', status);
  const { data } = await apiClient.get(`/api/contracts?${params.toString()}`);
  return data;
};

export const fetchActiveContracts = async () => {
  const { data } = await apiClient.get('/api/contracts/active');
  console.log(data);
  return data;
};

export const fetchContractById = async (id) => {
  const { data } = await apiClient.get(`/api/contracts/${id}`);
  return data;
};

export const createContract = async (payload) => {
  const { data } = await apiClient.post('/api/contracts', payload);
  return data;
};

export const updateContract = async ({ id, payload }) => {
  const { data } = await apiClient.patch(`/api/contracts/${id}`, payload);
  return data;
};

export const deleteContract = async (id) => {
  const { data } = await apiClient.delete(`/api/contracts/${id}`);
  return data;
};

export default fetchContracts;
